import { Sparkle, ArrowRight, Target } from "@phosphor-icons/react";

/** YadidAi "next move" suggestion panel — rendered below the playbook grid whenever
 * the partner has invoked the coach at least once. Stateless; parent owns fetching. */
export default function CoachPanel({ coach, onFocus }) {
  if (!coach) return null;
  return (
    <div className="border-t-2 border-primary/60 bg-primary/5 px-6 py-4" data-testid="playbook-coach-result">
      <div className="flex items-center gap-2 text-[0.625rem] font-mono uppercase tracking-widest text-primary mb-2">
        <Sparkle size={12} weight="fill" /> YadidAi · next move
        {coach.generated_at && (
          <span className="text-muted-foreground/70 normal-case tracking-normal ml-1" data-testid="coach-timestamp">
            · {String(coach.generated_at).slice(0, 16).replace("T", " ")} UTC
          </span>
        )}
      </div>
      {coach.suggested_prompt ? (
        <>
          <div className="text-sm font-medium text-foreground flex items-start gap-2">
            <ArrowRight size={14} weight="bold" className="text-primary shrink-0 mt-1" />
            <span data-testid="coach-prompt">{coach.suggested_prompt}</span>
          </div>
          <div className="text-xs text-muted-foreground mt-2 leading-relaxed" data-testid="coach-rationale">{coach.rationale}</div>
          {coach.encouragement && (
            <div className="text-[0.6875rem] italic text-primary/80 mt-2">{coach.encouragement}</div>
          )}
          <div className="text-[0.625rem] font-mono uppercase tracking-widest text-muted-foreground mt-2 flex items-center gap-3">
            <span>Section: {coach.suggested_section} · Item #{coach.suggested_idx}</span>
            <button
              onClick={() => onFocus?.(coach.suggested_section, coach.suggested_idx)}
              data-testid="coach-focus-btn"
              className="text-primary hover:text-primary/80 inline-flex items-center gap-1"
            >
              <Target size={11} weight="bold" /> Focus
            </button>
          </div>
        </>
      ) : (
        <div className="text-sm text-foreground">{coach.rationale || "Nothing to do — playbook is fully complete."}</div>
      )}
    </div>
  );
}
